import Vue from 'vue';
import App from './App.vue';
import './assets/lib/jquery/jquery.min.js';
import store from './store/store';
import './filters'
//import $ from 'jquery'
import JsonExcel from 'vue-json-excel'

Vue.component('downloadExcel', JsonExcel)

import VueSweetalert2 from 'vue-sweetalert2';

import { VueSpinners } from '@saeris/vue-spinners';

Vue.use(VueSpinners);

import VueGoodWizard from 'vue-good-wizard';

Vue.use(VueGoodWizard);

import ToggleButton from 'vue-js-toggle-button'

Vue.use(ToggleButton);

import NewAccountButton from "./components/button/NewAccountButton";
Vue.use(NewAccountButton);

import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

// require
Vue.use(require('vue-cookies'))

// es2015 module
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

// set default config
Vue.$cookies.config('7d')

// set global cookie
Vue.$cookies.set('theme','default');
Vue.$cookies.set('hover-time','1s');

import 'v-slim-dialog/dist/v-slim-dialog.css';
import SlimDialog from 'v-slim-dialog';

Vue.use(SlimDialog);

import vueCountryRegionSelect from 'vue-country-region-select';
Vue.use(vueCountryRegionSelect);

import Multiselect from 'vue-multiselect'

import VueClipboard from 'vue-clipboard2'

VueClipboard.config.autoSetContainer = true; // add this line
Vue.use(VueClipboard)

import Notifications from 'vue-notification'


const moment = require('moment')

require('moment/locale/es')

Vue.use(require('vue-moment'), {
  moment
})

Vue.prototype.moment = moment

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('DD-MMM-YYYY')
  }
});

/*
or for SSR:
import Notifications from 'vue-notification/dist/ssr.js'
*/

Vue.use(Notifications)

// register globally
Vue.component('multiselect', Multiselect);

import VueElementLoading from 'vue-element-loading';

const options = {
  confirmButtonColor: '#042893',
  cancelButtonColor: '#ff7674',
};

import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

import AirbnbStyleDatepicker from 'vue-airbnb-style-datepicker';
import 'vue-airbnb-style-datepicker/dist/vue-airbnb-style-datepicker.min.css';

import 'jquery-ui';

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap-select'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

import BaseButton from "./components/button/BaseButton";



import VueQrcode from '@chenfengyuan/vue-qrcode';

import router from './router'
import './registerServiceWorker'

import jQuery from 'jquery'

const datepickerOptions = {};

// make sure we can use it in our components
Vue.use(AirbnbStyleDatepicker, datepickerOptions);

Vue.use(VueSweetalert2, options);
window.jQuery = window.$ = jQuery;


Vue.component(VueQrcode.name, VueQrcode);
// import baseJs from './assets/_baseJs.js'
// Install BootstrapVue
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);

import VueTour from 'vue-tour';

require('vue-tour/dist/vue-tour.css');

Vue.use(VueTour);


// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.config.productionTip = false;

// const $ = require('jquery');

new Vue({
  router,
  BaseButton,
  store,
  VuePerfectScrollbar,
  vue2Dropzone,
  NewAccountButton,
  Multiselect,
  VueElementLoading,
  render: h => h(App)
}).$mount('#app');
